export default {
  path: '/out',
  name: 'out',
  component: () => import('@/views/out/index.vue'),
  children: [
    {
      path: 'login',
      name: 'login',
      component: () => import('@/views/out/login/index.vue'),
      meta: { requireAuth: false }
    },
    { path: '**', redirect: 'login' }
  ]
}
